export enum UserBookmarkCountBy {
    All = 0,
    Publication = 1,
    Collection = 2,
    Color = 3,
}
